export {ConfettiComponent} from './ConfettiComponent';
export type {ConfettiComponentDefinition} from './Confetti.types';
export {ComponentDefinition} from './ConfettiDefinition';
export type {SchemaType} from './ConfettiDefinition';
export {ConfettiPreviewComponent} from './ConfettiPreviewComponent';

import {Registry} from '@backstage-components/base';
import {ConfettiModule} from './ConfettiModule';
import {ComponentDefinition} from './ConfettiDefinition';
Registry.register(ComponentDefinition, ConfettiModule);
